export default __webpack_public_path__ + "static/media/bg_high.5cfe54a6.svg";